var $6SWs4$isomorphicuntar = $parcel$interopDefault(require("isomorphic-untar"));
var {unzip: $6SWs4$unzip} = require("gzip-js");

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b720a54303e5422ee234eb268923121e$export$9099ad97b570f7c);


function $569a9c1c44de471066bb0325aff15b6a$export$9099ad97b570f7c(buffer) {
    if (!buffer || buffer.length < 3) return false;
    return buffer[0] === 31 && buffer[1] === 139 && buffer[2] === 8;
}


function $b720a54303e5422ee234eb268923121e$var$isArrayBuffer(value) {
    return value instanceof ArrayBuffer || value instanceof SharedArrayBuffer;
}
function $b720a54303e5422ee234eb268923121e$export$9099ad97b570f7c(buffer) {
    if ($b720a54303e5422ee234eb268923121e$var$isArrayBuffer(buffer)) buffer = new Uint8Array(buffer);
    if (!(buffer instanceof Uint8Array)) throw new Error("Buffer should be an ArrayBuffer, SharedArrayBuffer or Uint8Array");
    if ($569a9c1c44de471066bb0325aff15b6a$export$9099ad97b570f7c(buffer)) buffer = new Uint8Array($6SWs4$unzip(buffer));
    return $6SWs4$isomorphicuntar(buffer.buffer);
}


//# sourceMappingURL=browser.js.map
